async function validateURL(e) {
  try {
    const t = new URL(e),
      r = Date.now(),
      { pathname: a, origin: s } = t,
      o = `${s}${a}?${r}`;
    if ((await fetch(o)).ok) return o;
  } catch (e) {
    error(e);
  }
  return null;
}
var { error: error } = console,
  Selector_Loading = ".TIB-Image-Loading",
  Selector_Error = ".TIB-Image-Error",
  Selector_Image = ".TIB-Image";
class Component extends HTMLElement {
  parts;
  constructor() {
    (super(),
      (this.parts = {
        loading: this.querySelector(Selector_Loading),
        error: this.querySelector(Selector_Error),
        image: this.querySelector(Selector_Image),
      }),
      this.loadImage());
  }
  set status(e) {
    this.dataset.status = e;
  }
  async getValidated() {
    const { src: e } = this.parts.image;
    return await validateURL(e);
  }
  async loadImage() {
    const { image: e } = this.parts;
    this.status = "Loading";
    let t = 0;
    const r = setInterval(async () => {
      if ((t++, t > 0)) {
        const a = await this.getValidated();
        if (a) {
          clearInterval(r);
          this.querySelectorAll(Selector_Image).forEach(img => {
              img.src = a;
          });
          setTimeout(
            () => {
              this.status = "Success";
            },
            1 === t ? 1500 : 0,
          );
        }
      } else (clearInterval(r), (this.status = "Error"));
    }, 2e3);
  }
}
customElements.define("reloaded-tib-image", Component);
